import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { UserCompaniesHttpService } from '../../../user-companies-http.service';
import {
  loadUserCompanies,
  loadUserCompaniesFailure,
  loadUserCompaniesSuccess,
} from '../actions/user-companies.actions';

@Injectable()
export class LoadUserCompaniesEffects {
  constructor(
    private actions: Actions,
    private userCompaniesHttpService: UserCompaniesHttpService,
  ) {}

  loadUserCompanies = createEffect(() => {
    return this.actions.pipe(
      ofType(loadUserCompanies),
      mergeMap(() => {
        return this.userCompaniesHttpService.getUserCompanies().pipe(
          map((companies) =>
            loadUserCompaniesSuccess({
              companies,
            }),
          ),
          catchError((error) => of(loadUserCompaniesFailure())),
        );
      }),
    );
  });
}
